module.exports = __webpack_public_path__ + "img/logo-small.de8eeb2d.png";